import React, { useState } from 'react';
import { Eye } from 'lucide-react';

export default function FeatureFlipCard({
  icon: Icon,
  title,
  desc,
  tag,
  color,
  iconColor,
  MockupComponent,
}) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div
      className={`flip-card ${flipped ? 'flipped' : ''}`}
      onMouseEnter={() => setFlipped(true)}
      onMouseLeave={() => setFlipped(false)}
      onClick={() => setFlipped((f) => !f)}
      style={{ perspective: '1000px' }}
    >
      <div
        className="flip-card-inner relative w-full"
        style={{
          transformStyle: 'preserve-3d',
          transition: 'transform 0.6s cubic-bezier(0.4,0,0.2,1)',
          transform: flipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
        }}
      >
        {/* ── Front Face ────────────────────────────── */}
        <div
          className="flip-card-front w-full bg-white/[0.03] backdrop-blur rounded-2xl p-6 border border-white/[0.07] relative overflow-hidden group"
          style={{ backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden' }}
        >
          {/* Gradient glow bg */}
          <div
            className={`absolute inset-0 bg-gradient-to-br ${color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
          />
          <div className="relative z-10">
            <div className="flex items-center justify-between mb-4">
              <div className="w-11 h-11 rounded-xl bg-white/[0.06] flex items-center justify-center">
                <Icon size={22} className={iconColor} />
              </div>
              <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 bg-white/[0.05] px-2.5 py-1 rounded-full">
                {tag}
              </span>
            </div>
            <h3 className="text-[15px] font-bold text-white mb-2 leading-snug">{title}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{desc}</p>

            {/* Flip hint */}
            <div className="mt-4 flex items-center gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <Eye size={12} className="text-violet-400" />
              <span className="text-[10px] text-violet-400 font-medium">Hover to preview</span>
            </div>
          </div>
        </div>

        {/* ── Back Face ─────────────────────────────── */}
        <div
          className="flip-card-back absolute inset-0 w-full bg-white/[0.03] backdrop-blur rounded-2xl border border-white/[0.07] overflow-hidden flex flex-col"
          style={{
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transform: 'rotateY(180deg)',
          }}
        >
          {/* Tag bar */}
          <div
            className={`px-4 py-2 bg-gradient-to-r ${color} border-b border-white/[0.06] flex items-center justify-between`}
          >
            <div className="flex items-center gap-2">
              <Icon size={14} className={iconColor} />
              <span className="text-[11px] font-bold text-white">{tag}</span>
            </div>
            <span className="text-[9px] text-slate-400 font-medium">Live Preview</span>
          </div>

          {/* Mockup */}
          <div className="flex-1 p-2 overflow-hidden">
            <MockupComponent size="sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
